/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_DogInputs */

const en_val_dog = /** @type {(inputs: Val_DogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dog`)
};

const es_val_dog = /** @type {(inputs: Val_DogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perro`)
};

const fr_val_dog = /** @type {(inputs: Val_DogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chien`)
};

const de_val_dog = /** @type {(inputs: Val_DogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hund`)
};

const ja_val_dog = /** @type {(inputs: Val_DogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`犬`)
};

const zh_val_dog = /** @type {(inputs: Val_DogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`狗`)
};

const ar_val_dog = /** @type {(inputs: Val_DogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`كلب`)
};

const id_val_dog = /** @type {(inputs: Val_DogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anjing`)
};

const it_val_dog = /** @type {(inputs: Val_DogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cane`)
};

const ru_val_dog = /** @type {(inputs: Val_DogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Собака`)
};

const pt_val_dog = /** @type {(inputs: Val_DogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cachorro`)
};

const ko_val_dog = /** @type {(inputs: Val_DogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`개`)
};

/**
* | output |
* | --- |
* | "Dog" |
*
* @param {Val_DogInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_dog = /** @type {((inputs?: Val_DogInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_DogInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_dog(inputs)
	if (locale === "es") return es_val_dog(inputs)
	if (locale === "fr") return fr_val_dog(inputs)
	if (locale === "de") return de_val_dog(inputs)
	if (locale === "ja") return ja_val_dog(inputs)
	if (locale === "zh") return zh_val_dog(inputs)
	if (locale === "ar") return ar_val_dog(inputs)
	if (locale === "id") return id_val_dog(inputs)
	if (locale === "it") return it_val_dog(inputs)
	if (locale === "ru") return ru_val_dog(inputs)
	if (locale === "pt") return pt_val_dog(inputs)
	return ko_val_dog(inputs)
});